module.exports = __webpack_public_path__ + "officialStatic/img/solution-factory.3f7d702.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/solution-factory.png
// module id = Dc+d
// module chunks = 0